import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { IconButton, TableCell, TableHead, TableRow } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import { commonTableStyles as styles } from "./tableStyles";

export type SortConfig = {
  colId: string;
  direction: any;
};
export type TableHeaderItem = {
  id: string;
  label: string;
  canSort: boolean;
};
export type SortFn = (id: string) => void;
interface TableHeaderProps {
  columns: TableHeaderItem[];
  handleSort: (id: string) => void;
  currentSortConfig: SortConfig;
}
export const TableHeader = ({
  columns,
  handleSort = (_) => {},
  currentSortConfig,
}: TableHeaderProps) => {
  return (
    <TableHead sx={{ ...styles.tableHeader }}>
      <TableRow sx={styles.headerRow}>
        {columns.map((column) => (
          <TableCell key={column.id}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <div>{column.label}</div>
              {column.canSort && (
                <IconButton size="small" onClick={() => handleSort(column.id)}>
                  {currentSortConfig.direction == "1" ||
                  currentSortConfig.direction == "asc" ? (
                    <ArrowUpward
                      sx={{
                        color: grey[900],
                      }}
                      fontSize="small"
                    />
                  ) : (
                    <ArrowDownward
                      sx={{
                        color: grey[900],
                      }}
                      fontSize="small"
                    />
                  )}
                </IconButton>
              )}
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
